import type {
  SearchMake,
  SearchModel,
  SearchResponse,
} from '@cinch-nx/data-search'
import { Env, readFromEnv } from '@cinch-nx/environments'
import { fetchSearchVehicles } from '@retail-common/data-search-vehicles-api'
import { VehicleCondition, VehiclesData } from '../../types/vehicles-data'

export interface GetVehiclesDataParams {
  vehicleCondition: VehicleCondition
  byMonthlyPrice?: boolean
  maxTotalPrice?: number
  make?: string
  model?: string
}

export const getVehiclesData = async ({
  vehicleCondition,
  byMonthlyPrice = true,
  maxTotalPrice,
  make,
  model,
}: GetVehiclesDataParams): Promise<{
  vehiclesData: VehiclesData
  searchResponse: SearchResponse
}> => {
  const data = await fetchSearchVehicles(readFromEnv(Env.SearchServiceUrl), {
    pageSize: 0,
    condition: [vehicleCondition],
    ...(byMonthlyPrice && {
      financeType: ['any'],
    }),
    ...(maxTotalPrice &&
      maxTotalPrice > 0 && {
        toPrice: [maxTotalPrice.toString()],
      }),
    ...(make && {
      make: [make],
    }),
    ...(model && {
      model: [model],
    }),
    ...(vehicleCondition === VehicleCondition.New && {
      includeVirtual: true,
    }),
  })
  const searchResponse = data.response as unknown as SearchResponse

  const makesData = searchResponse.facets.makes
  const makes = makesData.map((searchMake: SearchMake) => ({
    name: searchMake.name,
    stock: searchMake.doc_count,
    models: searchMake.models.map((searchModel: SearchModel) => ({
      name: searchModel.name,
      stock: searchModel.doc_count,
    })),
  }))

  const carTypes = {
    ...searchResponse.facets.bodyType,
    electric: searchResponse.facets.fuelType.electric,
  }
  const vehiclesData = {
    makes,
    carTypes,
    totalStock: searchResponse.searchResultsCount,
    monthlyPriceBucket: searchResponse.facets.monthlyPriceBucket,
    priceBucket: searchResponse.facets.priceBucket,
  }

  return { vehiclesData, searchResponse }
}
